import {media} from "../../frame";

export const onlyTable = `@media(max-width: ${media.n.tablet}) and (min-width: ${media.n.phone})`;
